export const endpoints = {
  authenticate: "/api/idm/v1/login",
  resetSenha: "/api/idm/v1/senha",
  termoAceite: "/api/termo-aceite/v1/termo?tipoDocumento=1&status=true",
  listarDdi: "/api/utils/ddi",
  cadastro: "/api/idm/v2/usuarios",
  getInstituicoes: "/api/gerar-remessa/v1/instituicao-liquidacao",
  atualizarSenha: "/api/idm/v1/senha",
  listarConglomerados:
    "/api/instituicao-regime-especial/v1/conglomerado-corporativo",
  listarDecendios: "/api/dominios/v1/decendio",
  listarRelatorioDecendio: "/api/pagamento-decendial/v1/posicoes",
  exportacaoPagamentos: "/api/pagamento-decendial/v1/posicoes/export",
  ibmPermissoes: "/api/corp/idm/v1/permissoes",
};
